import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnergyService } from '../services/energy-service';
import { EnergyStatisticsDay } from '../models/energy-statistics-day-model';
import { EnergyStatisticsMonth } from '../models/energy-statistics-month-model';

import moment from 'moment';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
    selector: 'app-energy-list',
    templateUrl: './energy-list.component.html',
    styleUrls: ['./energy-list.component.css'],
    providers: [EnergyService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EnergyListComponent implements OnInit {
  energyReadingsDayArr: Array<EnergyStatisticsDay>;
  energyReadingsMonthArr: Array<EnergyStatisticsMonth>;

  public lineChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: []
  };

    constructor(
    private energyService: EnergyService) {}

    public lineChartOptions: any = {
      responsive: true,
      interaction: {
        mode: 'index',
        intersect: false
      },
      scales: {
        x: {
          ticks: {
            display: true,
            maxTicksLimit: 31
          }
        },
        ENERGY: {
          type: 'linear',
          position: 'left',
          beginAtZero: true,
          ticks: {
            maxTicksLimit: 5
          }
        },
        TEMP: {
          type: 'linear',
          position: 'right',
          display: true,
          ticks: {
            maxTicksLimit: 5
          }
        }
      },
      elements: {
        point: {
          radius: 3
        },
        line: {
          tension: 0.4
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          mode: 'index',
          intersect: false
        },
        crosshair: {
          line: {
            color: '#666',
            width: 1,
            dash: [5, 5]
          },
          snap: {
            enabled: true
          },
          zoom: {
            enabled: false
          }
        }
      }
    };

    public lineChartType : ChartType = 'line';      // events
      public chartClicked(e: any): void {
      }

      public chartHovered(e: any): void {
      }

    ngOnInit() {
      this.energyService.getDayStatisticalLst('7').subscribe(data => {
        this.energyReadingsDayArr = data;
      },
      error => undefined
      );

      this.energyService.getDayStatisticalMonthLst('7').subscribe(data => {
        // Calculate avgConsumptionInWatts per element
        for (const inst of data) {
          EnergyStatisticsMonth.OnDeserialized(inst);
        }

        this.energyReadingsMonthArr = data;
        this.fixlineChartData();
      },
      error => undefined
      );
    }

    private fixlineChartData() {
      const dataArrEnergy = new Array<number>();
      const dataArrTempAvg = new Array<number>();
      const dataArrTempMin = new Array<number>();
      const dataArrTempMax = new Array<number>();

      const labelArr = new Array<string>();

      if (this.energyReadingsMonthArr != null) {
        for (const element of this.energyReadingsMonthArr) {
          dataArrEnergy.push(element.dayKwh);
          dataArrTempAvg.push(element.avgTemp);
          dataArrTempMin.push(element.minTemp);
          dataArrTempMax.push(element.maxTemp);

          labelArr.push(moment(element.dateOfReading).format('DD/MM-YY'));
        }

        this.lineChartData = {
          labels: labelArr,
          datasets: [
            {
              data: dataArrEnergy,
              label: 'Energy',
              fill: 'origin',
              yAxisID: 'ENERGY',
              backgroundColor: 'rgba(77,83,96,0.2)',
              borderColor: 'rgba(77,83,96,1)',
              pointBackgroundColor: 'rgba(77,83,96,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(77,83,96,1)'
            },
            {
              data: dataArrTempAvg,
              label: 'Avg temp',
              fill: false,
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(148,159,177,0.2)',
              borderColor: 'rgba(148,159,177,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
              data: dataArrTempMin,
              label: 'Min temp',
              fill: false,
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(50,162,236,0.2)',
              borderColor: 'rgba(50,162,236,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
              data: dataArrTempMax,
              label: 'Max temp',
              fill: false,
              yAxisID: 'TEMP',
              backgroundColor: 'rgba(220,20,60,0.2)',
              borderColor: 'rgba(220,20,60,1)',
              pointBackgroundColor: 'rgba(148,159,177,1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            }
          ]
        };
      }
    }
}
